<template>
    <div class="AppSynopsis">
        <div class="banner inner">
            <img v-if="$store.state.user.banner.banner2" style="width:100%;" :src="$store.state.user.banner.banner2" alt="banner">
        </div>
        <div class="content">
            <div class="inner">
                <div>
                    <app-synopsis-title class="app_title"></app-synopsis-title>
                    <div class="app_content">
                        <div class="phone1_box phone_box">
                            <div class="phone_item">
                                <img src="~@/assets/images/phone1.png" alt="">
                            </div>
                            <div class="phone_item right">
                                <AppSynopsisSubTitle></AppSynopsisSubTitle>
                                <p>技能河南一站式通用学习平台，所包含功能全面，简单易操作，注重数字知识运营，邀请名师进行录制课程，提供专业的在线学习，模拟考试，帮助学员快速提升技能知识，获取国家职业资格证书</p>
                            </div>
                        </div>
                        <div class="phone2_box phone_box">
                            <div class="phone_item">
                                <img src="~@/assets/images/phone2.png" alt="">
                            </div>
                            <div class="phone_item right">
                                <AppSynopsisSubTitle>技能河南·人人持证</AppSynopsisSubTitle>
                                <p>主要功能包括：在线报名、在线学习、模拟考试、学习査询、实名制注册、人脸识别、学习过程习题练习开展＂互联网＋职业培训＂推动助力培养大批高素质劳动者和技术技能人才。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="advantage">
                    <app-synopsis-title class="app_title">平台优势</app-synopsis-title>
                    <ul class="advantage_content">
                        <li class="left">
                            <div class="item top">
                                <h5>学习全程管控</h5>
                                <p>学习过程中根据所讲知识点，智能弹出试
题进行练习帮助学员快速掌握知识点。</p>
                            </div>
                            <div class="item bottom">
                                <h5>智能活体人脸识别</h5>
                                <p>通过活体人脸识别功能防止学员在观看课
程时进行刷课行为，提升学习效率。</p>
                            </div>
                        </li>
                        <li class="center">
                            <h5>平台优势</h5>
                        </li>
                        <li class="right">
                            <div class="item top">
                                <h5>专业名师监督</h5>
                                <p>邀请专业名师录制，将每一个知识点
通过简单易懂的方式讲解。</p>
                            </div>
                            <div class="item bottom">
                                <h5>智能模拟考试</h5>
                                <p>课后模拟练习，智能模拟考试，帮助学员掌
握所学到的没一个知识点。</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppSynopsisTitle from '@/components/AppSynopsisTitle'
import AppSynopsisSubTitle from '@/components/AppSynopsisSubTitle'
export default {
    components:{
        AppSynopsisTitle,
        AppSynopsisSubTitle
    }
}
</script>
<style lang="scss" scoped>
.AppSynopsis{
    background: #fff;
    .content{
        padding-top: 99px;
    }
    .advantage{
        padding-bottom: 270px;
        .advantage_content{
            display: flex;
            align-items: center;
            justify-content: center;
            .item{
                width: 470px;
                height: 250px;
                border: 2px solid #3963E4;
                margin: 50px 0;
                border-radius: 20px;
                padding: 49px 56px 0;
                
                h5{
                    font-size: 40px;
                    font-weight: 800;
                    color: #3964E6;
                    margin-bottom: 20px;
                    text-align: center;
                }
                p{
                    font-size: 18px;
                    font-weight: 800;
                    color: #3964E6;
                    line-height: 1.8;
                }
            }
            .top{
                margin-bottom: 100px;
            }
            .bottom{
                margin-top: 100px;
            }
            .center{
                height: 258px;
                width: 258px;
                border: 2px solid #3963E4;
                border-radius: 50%;
                transform: scale(1.06);
                color: #3964E6;
                display: flex;
                align-items: center;
                justify-content: center;
                h5{
                    font-size: 50px;
                    font-weight: 800;
                }
            }
        }
    }
    .app_title{
        margin-bottom: 69px;
    }
    .app_content{
        .phone1_box{
            display: flex;
            align-items:center;
            margin-bottom: 100px;
            // flex-direction: row-reverse;
        }
        .phone2_box{
            display: flex;
            align-items:center;
            flex-direction: row-reverse;
            margin-bottom: 150px;
        }
        .phone_item{
            width: 50%;
            p{
                line-height: 1.8;
            }
        }
        .phone_box:nth-child(odd){
            .right{
                padding-left: 50px;
            }
        }
        .phone_box:nth-child(even){
            .right{
                padding-right: 50px;
            }
        }
    }
}
</style>